import { LocalDataTrack, LocalVideoTrack } from 'twilio-video';

/**
 * Tira uma foto da câmera traseira, baixa no dispositivo e envia para a API da Ativa.
 */
export async function takePrintScreen(
  videoTrack: LocalVideoTrack,
  localDataTrack: LocalDataTrack,
  params: { URLModulo?: string; URLRoomName?: string }
) {
  const { URLModulo, URLRoomName } = params;

  if (!URLModulo || !URLRoomName) {
    console.warn('[takePrintScreen] Parâmetros ausentes:', { URLModulo, URLRoomName });
    return;
  }

  try {
    // Captura a imagem da câmera
    const deviceId = videoTrack.mediaStreamTrack.getSettings().deviceId;
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { deviceId: { exact: deviceId } },
    });

    const video = document.createElement('video');
    video.srcObject = stream;
    video.play();

    await new Promise(resolve => {
      video.onloadedmetadata = () => resolve(true);
    });

    const scale = 2;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth * scale;
    canvas.height = video.videoHeight * scale;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Não foi possível obter contexto do canvas');

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    stream.getTracks().forEach(track => track.stop());

    const base64 = canvas.toDataURL('image/png');
    const fileName = `Foto_${URLModulo}.png`;

    // 🔽 Download da imagem
    // const link = document.createElement('a');
    // link.href = base64;
    // link.download = fileName;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);

    // ☁️ Upload da imagem
    const base64Short = base64.substring(base64.indexOf(',') + 1);
    const image = {
      conteudo: base64Short,
      arquivo: fileName,
      categoria: 'categoria',
    };

    let modulo = '';
    switch (URLModulo) {
      case 'telereg':
        modulo = 'regulacao';
        break;
      case 'teleinsp':
        modulo = 'inspecao';
        break;
      default:
        throw new Error(`Módulo inválido: ${URLModulo}`);
    }

    const response = await fetch(
      `https://cosmos.ativapericias.com.br/auto/${modulo}/tele/${URLRoomName}/enviar-fotos`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(image),
      }
    );

    if (!response.ok) throw new Error('Erro ao enviar imagem');
    const data = await response.json();
    console.log('[☁️ Upload] Imagem enviada com sucesso:', data);

    // 📤 Feedback via DataTrack
    localDataTrack.send(
      JSON.stringify({
        tipo: 'resposta_foto',
        status: 'success',
        mensagem: 'Foto remota tirada e enviada com sucesso!',
      })
    );
  } catch (error) {
    console.error('[❌ takePrintScreen] Erro ao tirar/enviar foto:', error);
    localDataTrack.send(
      JSON.stringify({
        tipo: 'resposta_foto',
        status: 'error',
        mensagem: 'Erro ao tirar ou enviar a foto remota',
      })
    );
  }
}
